// mobil.js – Handy-Darstellung: Reiter als Menü (Burger-Knopf mit Liste) und Filtergruppen als Auswahllisten. Teil der App-Baseline (design/).
// Bis 600 px Breite ersetzt ein Menü (Knopf mit ≡ und aktuellem Abschnitt, darunter die Liste) die Reiterleiste (sobald die Reiter nicht in eine Zeile passen), und jede Filtergruppe wird zu einer
// Auswahlliste mit Häkchen („Abteilung (2) ▾“). Die Auswahl entsteht aus dem vorhandenen Markup (.wb-tabs/.wb-tab,
// .wb-filter/.wb-filter-group/.wb-label; die deutschen Namen .wb-filter-gruppe, .wb-zaehler, .aktiv, .wb-umbruch gelten in der Übergangsphase weiter) und bedient die Originalschaltflächen; die App braucht keine eigene Logik.
// Einbinden: <script src="mobil.js?v=<Version>"></script> nach den App-Skripten (oder davor, es beobachtet die Seite).
// Das Aussehen steckt in design.css (.wb-tabs-select, .wb-filter-mobile, .wb-filter-select). Ab 600 px bleibt alles beim Alten.
(function () {
  "use strict";

  var MIN_REITER = 2;      // ab so vielen Reitern kann die Reiterleiste auf dem Handy zur Auswahl werden (wenn sie nicht in eine Zeile passt)
  var offen = {};          // geöffnete Filtergruppen (Name → true); bleibt beim Neuzeichnen der Filterzeile erhalten

  function el(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text !== undefined) e.textContent = text;
    return e;
  }
  function begleiter(knoten, klasse) {
    var n = knoten.nextElementSibling;
    return n && n.classList.contains(klasse) ? n : null;
  }
  function entferne(knoten, klasse) {
    var b = begleiter(knoten, klasse);
    if (b) b.remove();
    if (knoten.hasAttribute("data-mobil")) knoten.removeAttribute("data-mobil");
  }

  // ---- Reiter ----
  function reiterName(knopf) {
    var z = knopf.querySelector(".wb-count, .wb-zaehler");
    var name = (knopf.textContent || "").replace(/\s+/g, " ").trim();
    if (!z) return name;
    var zahl = (z.textContent || "").trim();
    return name.slice(0, name.length - zahl.length).trim() + " (" + zahl + ")";
  }
  function sichtbareReiter(nav) {
    return Array.prototype.filter.call(nav.querySelectorAll(".wb-tab"), function (b) { return !b.hidden && getComputedStyle(b).display !== "none"; });   // ausgeblendet = Attribut hidden oder eine Klasse der App (z. B. .hidden bei rollenabhängigen Reitern)
  }
  function menueSymbol() {
    var ns = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns, "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("aria-hidden", "true");
    [6, 12, 18].forEach(function (y) {
      var l = document.createElementNS(ns, "line");
      l.setAttribute("x1", "4"); l.setAttribute("x2", "20"); l.setAttribute("y1", String(y)); l.setAttribute("y2", String(y));
      svg.appendChild(l);
    });
    return svg;
  }
  // Symbol-Reiter (seit 1.134.0, Opt-in data-icon="settings" oder "info" am .wb-tab): fügt das Symbol ein (nur auf dem Handy sichtbar, design.css), setzt title und aria-label
  // und merkt den ersten sichtbaren Symbol-Reiter (data-icon-first), damit die Symbole rechts in der Reiterzeile stehen.
  var REITER_SYMBOLE = {
    settings: '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5.5"/><circle cx="12" cy="7.8" r=".6" fill="currentColor"/>'
  };
  function reiterSymbole(nav, knoepfe) {
    Array.prototype.forEach.call(nav.querySelectorAll(".wb-tab[data-icon-first]"), function (b) { b.removeAttribute("data-icon-first"); });
    var erster = true;
    knoepfe.forEach(function (k) {
      var art = k.getAttribute("data-icon");
      if (!art || !REITER_SYMBOLE[art]) return;
      if (!k.querySelector(".wb-tab-icon")) {
        k.insertAdjacentHTML("beforeend", '<svg class="wb-tab-icon" viewBox="0 0 24 24" aria-hidden="true">' + REITER_SYMBOLE[art] + "</svg>");
      }
      var name = reiterName(k);
      if (k.getAttribute("aria-label") !== name) k.setAttribute("aria-label", name);
      if (k.getAttribute("title") !== name) k.setAttribute("title", name);
      if (erster) { k.setAttribute("data-icon-first", ""); erster = false; }
    });
  }
  function schliesseReiterMenue(box) {
    box.classList.remove("open");
    box.querySelector(".wb-menu-button").setAttribute("aria-expanded", "false");
    box.querySelector(".wb-tabs-list").hidden = true;
  }
  // "Mehr"-Menü (seit 1.136.0, Opt-in data-more am .wb-tab): Reiter mit data-more (z. B. Einstellungen, Info) stehen bis 600 px nicht in der Reiterzeile, sondern in einem Menü hinter einem Knopf mit ≡
  // rechts in der Zeile; die übrigen Reiter bleiben klassische Reiter. Das gilt nur, wenn diese Reiter samt Knopf in eine Zeile passen; sonst ersetzt wie bisher das Menü die Leiste (mit allen Reitern).
  function schliesseMehr(nav) {
    var k = nav.querySelector(".wb-tabs-more-button");
    var l = nav.querySelector(".wb-tabs-more-list");
    if (k) k.setAttribute("aria-expanded", "false");
    if (l) l.hidden = true;
  }
  var mehrGlobal = false;
  function mehrSync(nav, mehr, aktivReiter, nurKnopf) {
    var knopf = nav.querySelector(".wb-tabs-more-button");
    var liste = nav.querySelector(".wb-tabs-more-list");
    if (!mehr.length) {
      if (knopf) knopf.remove();
      if (liste) liste.remove();
      return;
    }
    if (!knopf) {
      knopf = el("button", "wb-tabs-icon wb-tabs-more-button");
      knopf.type = "button";
      knopf.setAttribute("aria-haspopup", "menu");
      knopf.setAttribute("aria-expanded", "false");
      knopf.appendChild(menueSymbol());
      liste = el("div", "wb-tabs-list wb-tabs-more-list");
      liste.setAttribute("role", "menu");
      liste.hidden = true;
      knopf.addEventListener("click", function () {
        var auf = liste.hidden;
        liste.hidden = !auf;
        knopf.setAttribute("aria-expanded", String(auf));
      });
      nav.addEventListener("keydown", function (e) { if (e.key === "Escape") { schliesseMehr(nav); knopf.focus(); } });
      nav.appendChild(knopf);
      nav.appendChild(liste);
      if (!mehrGlobal) {
        mehrGlobal = true;
        document.addEventListener("click", function (e) {
          Array.prototype.forEach.call(document.querySelectorAll(".wb-tabs"), function (n) {
            if (!n.contains(e.target) || !(e.target.closest && e.target.closest(".wb-tabs-more-button, .wb-tabs-more-list"))) schliesseMehr(n);
          });
        });
      }
    }
    if (nurKnopf) return;   // beim Messen (Überlauf) genügt der Knopf; die Liste wird erst am Ende gebaut, sonst entstünde sie bei jedem Abgleich mehrfach neu
    var namen = mehr.map(reiterName);
    var sig = namen.join("\u0001");
    if (knopf.dataset.sig !== sig) {
      knopf.dataset.sig = sig;
      var beschriftung = "Weitere Abschnitte: " + namen.join(", ");
      knopf.title = beschriftung;
      knopf.setAttribute("aria-label", beschriftung);
      liste.textContent = "";
      namen.forEach(function (n, i) {
        var b = el("button", "wb-tabs-item");
        b.type = "button";
        b.setAttribute("role", "menuitemradio");
        b.title = n;
        b.appendChild(el("span", "", n));
        b.addEventListener("click", function () {
          var k = Array.prototype.filter.call(nav.querySelectorAll(".wb-tab[data-more], .wb-tab[data-overflow]"), function (x) { return !x.hidden && reiterName(x) === n; })[0];   // nicht über sichtbareReiter: bei aktivem Mehr-Menü sind diese Reiter per CSS ausgeblendet (display: none), und der Tipp auf den Eintrag fand keinen Reiter
          schliesseMehr(nav);
          if (k) k.click();
        });
        liste.appendChild(b);
      });
    }
    var an = mehr.indexOf(aktivReiter) >= 0;
    if (knopf.classList.contains("active") !== an) knopf.classList.toggle("active", an);
    Array.prototype.forEach.call(liste.children, function (b, i) {
      var c = String(mehr[i] === aktivReiter);
      if (b.getAttribute("aria-checked") !== c) b.setAttribute("aria-checked", c);
    });
  }

  function istMehr(k) { return k.hasAttribute("data-more") || k.hasAttribute("data-overflow"); }
  function reiterSync(nav) {
    Array.prototype.forEach.call(nav.querySelectorAll(".wb-tab[data-overflow]"), function (k) { k.removeAttribute("data-overflow"); });
    nav.removeAttribute("data-mehr");   // zuerst alle Reiter sichtbar (data-more-Reiter sind sonst ausgeblendet und fehlten im Menü)
    var knoepfe = sichtbareReiter(nav);
    reiterSymbole(nav, knoepfe);
    if (knoepfe.length < MIN_REITER) { entferne(nav, "wb-tabs-select"); nav.removeAttribute("data-mobil"); return; }
    var box = begleiter(nav, "wb-tabs-select");
    if (!box) {
      box = el("div", "wb-tabs-select");
      var knopf = el("button", "wb-menu-button");
      knopf.type = "button";
      knopf.setAttribute("aria-haspopup", "menu");
      knopf.setAttribute("aria-expanded", "false");
      knopf.setAttribute("aria-label", "Abschnitt wählen");
      knopf.appendChild(menueSymbol());
      knopf.appendChild(el("span", "wb-menu-name"));
      var liste = el("div", "wb-tabs-list");
      liste.setAttribute("role", "menu");
      liste.hidden = true;
      knopf.addEventListener("click", function () {
        var auf = !box.classList.contains("open");
        box.classList.toggle("open", auf);
        knopf.setAttribute("aria-expanded", String(auf));
        liste.hidden = !auf;
      });
      box.addEventListener("keydown", function (e) { if (e.key === "Escape") { schliesseReiterMenue(box); knopf.focus(); } });
      box.appendChild(knopf);
      box.appendChild(liste);
      nav.parentNode.insertBefore(box, nav.nextSibling);
    }
    var liste2 = box.querySelector(".wb-tabs-list");
    // Reiter mit data-icon stehen im Menü-Fall als Symbolknöpfe rechts neben dem Menüknopf, das Menü enthält nur die übrigen Reiter
    var mitSymbol = knoepfe.filter(function (k) { return REITER_SYMBOLE[k.getAttribute("data-icon")]; });
    var imMenue = knoepfe.filter(function (k) { return mitSymbol.indexOf(k) < 0; });
    var namen = imMenue.map(reiterName);
    var symbolNamen = mitSymbol.map(reiterName);
    var sig = namen.join("\u0001") + "\u0002" + mitSymbol.map(function (k) { return k.getAttribute("data-icon"); }).join(",") + symbolNamen.join("\u0001");
    if (box.dataset.sig !== sig) {
      box.dataset.sig = sig;
      liste2.textContent = "";
      namen.forEach(function (n, i) {
        var b = el("button", "wb-tabs-item");
        b.type = "button";
        b.setAttribute("role", "menuitemradio");
        b.title = n;
        b.appendChild(el("span", "", n));
        b.addEventListener("click", function () {
          var k = sichtbareReiter(nav).filter(function (x) { return !REITER_SYMBOLE[x.getAttribute("data-icon")]; })[i];
          schliesseReiterMenue(box);
          if (k) k.click();
        });
        liste2.appendChild(b);
      });
      var alt = box.querySelector(".wb-tabs-icons");
      if (alt) alt.remove();
      box.classList.toggle("has-icons", mitSymbol.length > 0);
      if (mitSymbol.length) {
        var gruppe = el("div", "wb-tabs-icons");
        symbolNamen.forEach(function (n, i) {
          var b = el("button", "wb-tabs-icon");
          b.type = "button";
          b.title = n;
          b.setAttribute("aria-label", n);
          b.insertAdjacentHTML("beforeend", '<svg viewBox="0 0 24 24" aria-hidden="true">' + REITER_SYMBOLE[mitSymbol[i].getAttribute("data-icon")] + "</svg>");
          b.addEventListener("click", function () {
            var k = sichtbareReiter(nav).filter(function (x) { return REITER_SYMBOLE[x.getAttribute("data-icon")]; })[i];
            schliesseReiterMenue(box);
            if (k) k.click();
          });
          gruppe.appendChild(b);
        });
        box.appendChild(gruppe);
      }
    }
    var aktiv = 0;
    knoepfe.forEach(function (k, i) { if (k.getAttribute("aria-selected") === "true" || k.classList.contains("active") || k.classList.contains("aktiv")) aktiv = i; });
    var aktivReiter = knoepfe[aktiv];
    var name = box.querySelector(".wb-menu-name");
    var aktivName = reiterName(aktivReiter);
    if (name.textContent !== aktivName) name.textContent = aktivName;
    Array.prototype.forEach.call(liste2.children, function (b, i) {
      var an = String(imMenue[i] === aktivReiter);
      if (b.getAttribute("aria-checked") !== an) b.setAttribute("aria-checked", an);
    });
    var symbolKnoepfe = box.querySelectorAll(".wb-tabs-icon");
    Array.prototype.forEach.call(symbolKnoepfe, function (b, i) {
      var an = mitSymbol[i] === aktivReiter;
      if (b.classList.contains("active") !== an) b.classList.toggle("active", an);
      if (an) b.setAttribute("aria-current", "page"); else b.removeAttribute("aria-current");
    });
    // Das Menü ersetzt die Reiterleiste nur, wenn die Reiter nicht in eine Zeile passen (gemessen bei sichtbarer Leiste)
    nav.removeAttribute("data-mobil");
    // Überlauf ins „Mehr“-Menü (seit 1.170.0, Opt-in .wb-tabs.overflow-more): Passen die Reiter nicht in eine Zeile, stehen so viele wie möglich direkt als Reiter dort (in der Reihenfolge), die letzten wandern hinter den Knopf
    // mit ≡ (data-overflow, wie data-more); erst wenn nicht einmal ein Reiter samt Knopf passt, ersetzt das Menü die Leiste. Reiter mit data-more stehen dabei immer im Menü.
    var ueberlauf = nav.classList.contains("overflow-more");
    var frei = knoepfe.filter(function (k) { return !k.hasAttribute("data-more"); });
    var umbruch, n = 0;
    for (;;) {
      var mehrReiter = knoepfe.filter(istMehr);
      var inReihe = knoepfe.filter(function (k) { return !istMehr(k); });
      if (!ueberlauf || mehrReiter.length) mehrSync(nav, inReihe.length ? mehrReiter : [], aktivReiter, ueberlauf);   // beim Überlauf ohne Menü den vorhandenen Knopf nicht entfernen (er wird sonst bei jedem Abgleich neu erzeugt)
      if (mehrReiter.length && inReihe.length) {
        // erst mit denselben Maßen wie ohne Menü, passt das nicht in eine Zeile, mit den engeren Reitern (data-mehr="eng"; nicht beim Überlauf, dort wandert stattdessen ein Reiter ins Menü), sonst ersetzt das Menü die Leiste
        var mehrKnopf = nav.querySelector(".wb-tabs-more-button");
        var passtNicht = function () {
          var oben = inReihe[0].offsetTop;
          return inReihe.some(function (k) { return k.offsetTop > oben + 2; }) || Boolean(mehrKnopf && mehrKnopf.offsetTop > oben + 2);
        };
        nav.setAttribute("data-mehr", "");
        umbruch = passtNicht();
        if (umbruch && !ueberlauf) { nav.setAttribute("data-mehr", "eng"); umbruch = passtNicht(); }
        if (umbruch) nav.removeAttribute("data-mehr");
      } else {
        var oben2 = knoepfe[0].offsetTop;
        umbruch = knoepfe.some(function (k) { return k.offsetTop > oben2 + 2; });
      }
      var kandidat = frei[frei.length - 1 - n];
      if (!(umbruch && ueberlauf && inReihe.length > 1 && kandidat && !kandidat.hasAttribute("data-overflow"))) break;
      kandidat.setAttribute("data-overflow", "");
      n++;
    }
    if (umbruch) { schliesseMehr(nav); Array.prototype.forEach.call(nav.querySelectorAll(".wb-tab[data-overflow]"), function (k) { k.removeAttribute("data-overflow"); }); }   // erst am Ende schließen: beim Messen geht der Überlauf Reiter für Reiter durch, das offene Menü soll dabei stehen bleiben
    if (ueberlauf) {
      var endMehr = umbruch ? [] : knoepfe.filter(istMehr);
      mehrSync(nav, endMehr.length && knoepfe.length > endMehr.length ? endMehr : [], aktivReiter);
    }
    if (umbruch) nav.setAttribute("data-mobil", "");
  }

  // ---- Filtergruppen ----
  function gruppenName(gruppe) {
    var s = gruppe.firstElementChild;
    return ((s && s.textContent) || "").replace(/\s+/g, " ").trim().replace(/:$/, "");
  }
  function chips(gruppe) { return Array.prototype.slice.call(gruppe.querySelectorAll(".wb-label")); }
  // Einzelauswahl (seit 1.128.0, Opt-in .wb-filter-group.single): Es gilt immer genau eine Auswahl (z. B. Alle, Heute, Morgen). Die Auswahlliste zeigt dann statt der Zahl den gewählten Wert
  // ("Filter: Heute"), die Einträge sind Optionsfelder, ein Tippen wählt und schließt die Liste. Die erste Schaltfläche gilt als Grundzustand (die Auswahl ist erst bei einer anderen "aktiv" hervorgehoben).
  // Nur der Wert im Kopf (seit 1.156.0, Opt-in .wb-filter-group.single.value-only): Der Kopf der Auswahlliste zeigt den gewählten Wert ohne den Namen der Gruppe; ein Eintrag kann mit data-label eine kürzere oder
  // eindeutigere Beschriftung für den Kopf tragen (z. B. Schaltfläche „Alle“ mit data-label="Alle Status"). Name und Wert stehen weiter im aria-label und im Tooltip, die geöffnete Liste nennt den Namen als Überschrift.
  function nurWert(gruppe) { return einzeln(gruppe) && (gruppe.classList.contains("value-only") || gruppe.classList.contains("nur-wert")); }
  function einzeln(gruppe) { return gruppe.classList.contains("single") || gruppe.classList.contains("einzeln"); }
  var radioZaehler = 0;
  // Gruppen mit .always-pills (seit 1.131.0, Opt-in) bleiben auch auf Tablet und Handy Schaltflächen (Pillen) in der Filterzeile und werden keine Auswahlliste
  function listenGruppen(filter) { return Array.prototype.filter.call(filter.querySelectorAll(".wb-filter-group, .wb-filter-gruppe"), function (g) { return !g.classList.contains("always-pills"); }); }
  function filterSync(filter) {
    var gruppen = listenGruppen(filter);
    if (!gruppen.length || filter.hidden) { entferne(filter, "wb-filter-mobile"); return; }
    var struktur = gruppen.map(function (g) { return (einzeln(g) ? (nurWert(g) ? "2" : "1") : "0") + gruppenName(g) + "\u0002" + chips(g).map(function (c) { return c.textContent; }).join("\u0003"); }).join("\u0001");
    var box = begleiter(filter, "wb-filter-mobile");
    if (!box || box.dataset.struktur !== struktur) {
      if (box) box.remove();
      box = el("div", "wb-filter-mobile");
      radioZaehler++;
      box.dataset.struktur = struktur;
      gruppen.forEach(function (g, gi) {
        var name = gruppenName(g);
        var d = el("details", "wb-filter-select");
        d.dataset.name = name;
        if (offen[name]) d.open = true;
        d.addEventListener("toggle", function () { offen[name] = d.open; });
        // Titel in einem span: der Name wird bei schmaler Spalte mit „…“ gekürzt, die Zahl der gewählten Einträge „(2)“ bleibt sichtbar
        var kopfM = el("summary");
        var titelM = el("span", "wb-filter-title");
        titelM.appendChild(el("span", "wb-filter-name", name));
        titelM.appendChild(el("span", "wb-filter-count"));
        kopfM.appendChild(titelM);
        d.appendChild(kopfM);
        var liste = el("div", "wb-filter-list");
        if (nurWert(g)) liste.appendChild(el("div", "wb-filter-caption", name));   // Kopf zeigt nur den Wert: die Liste nennt, was gewählt wird
        chips(g).forEach(function (c, ci) {
          var l = el("label", "wb-option");
          var cb = el("input");
          var ein = einzeln(g);
          cb.type = ein ? "radio" : "checkbox";
          if (ein) cb.name = "wbf" + radioZaehler + "-" + gi;
          cb.addEventListener("change", function () {
            // Originalschaltfläche lazy suchen: die App zeichnet die Filterzeile nach jedem Klick neu
            var gr = listenGruppen(filter)[gi];
            var k = gr && chips(gr)[ci];
            if (k) k.click();
            if (ein) { d.open = false; offen[name] = false; }
          });
          l.appendChild(cb);
          l.title = c.textContent;
          l.appendChild(el("span", "", c.textContent));
          liste.appendChild(l);
        });
        d.appendChild(liste);
        box.appendChild(d);
      });
      filter.parentNode.insertBefore(box, filter.nextSibling);
    }
    // Zustand (Häkchen, Zähler) in jedem Fall nachziehen
    gruppen.forEach(function (g, gi) {
      var d = box.children[gi];
      var an = chips(g).map(function (c) { return c.classList.contains("active") || c.classList.contains("aktiv") || c.getAttribute("aria-pressed") === "true"; });
      var n = an.filter(Boolean).length;
      var ein = einzeln(g);
      var gewaehlt = ein ? chips(g)[an.indexOf(true)] : null;
      var titel = ein
        ? gruppenName(g) + (gewaehlt ? ": " + gewaehlt.textContent.trim() : "")
        : gruppenName(g) + (n ? " (" + n + ")" : "");
      var nameSpan = d.firstChild.querySelector(".wb-filter-name"), zaehler = d.firstChild.querySelector(".wb-filter-count");
      var nameText = ein ? titel : gruppenName(g), zaehlerText = !ein && n ? " (" + n + ")" : "";   // Einzelauswahl: „Name: Auswahl“ im gekürzten Teil; Mehrfachauswahl: Zahl bleibt sichtbar
      if (ein && nurWert(g)) {   // .value-only (seit 1.156.0): nur der Wert im Kopf (kürzer, mehr Köpfe in einer Zeile); der volle Text bleibt für Sprachausgabe und Tooltip
        nameText = gewaehlt ? (gewaehlt.getAttribute("data-label") || gewaehlt.textContent.trim()) : gruppenName(g);
        d.firstChild.setAttribute("aria-label", titel); d.firstChild.title = titel;
      }
      if (nameSpan.textContent !== nameText) nameSpan.textContent = nameText;
      if (zaehler.textContent !== zaehlerText) zaehler.textContent = zaehlerText;
      d.classList.toggle("active", ein ? an.indexOf(true) > 0 : n > 0);
      Array.prototype.forEach.call(d.querySelectorAll("input"), function (cb, i) { if (cb.checked !== an[i]) cb.checked = an[i]; });
    });
    if (!filter.hasAttribute("data-mobil")) filter.setAttribute("data-mobil", "");
  }

  // Lange Gruppen als Auswahlliste (seit 1.121.0, Opt-in .wb-filter.auto-list): Eine Gruppe mit mehr als LANGE_GRUPPE Einträgen wird ab 1000 px durch eine Auswahlliste mit Häkchen in der Filterzeile
  // ersetzt (Kopf in Pillengröße mit dem Symbol der Gruppe, Liste wie auf dem Handy). Die Gruppe bleibt als Quelle im Markup (data-as-list, per CSS ausgeblendet), die Häkchen bedienen ihre Schaltflächen.
  // Zeichnet die App die Filterzeile neu, baut mobil.js die Liste beim nächsten Durchlauf wieder auf (offen/zu merkt es sich).
  var LANGE_GRUPPE = 6;
  function langeGruppen(filter) {
    var auto = filter.classList.contains("auto-list") && !filter.hidden;
    Array.prototype.forEach.call(filter.querySelectorAll(".wb-filter-group, .wb-filter-gruppe"), function (g, gi) {
      var nach = g.nextElementSibling;
      var d = nach && nach.classList.contains("wb-filter-select") ? nach : null;
      var lang = auto && !g.classList.contains("keep-pills") && (chips(g).length > LANGE_GRUPPE || g.classList.contains("as-list"));   // .as-list (seit 1.142.0, Opt-in): auch eine kurze Gruppe wird ab 1000 px zur Auswahlliste; .keep-pills (seit 1.147.0, Opt-in): auch eine lange Gruppe bleibt ab 1000 px Pillen (Tablet und Handy: weiter Auswahlliste)
      if (!lang) { g.removeAttribute("data-as-list"); if (d) d.remove(); return; }
      var name = gruppenName(g);
      var k = chips(g);
      var struktur = name + "\u0002" + k.map(function (c) { return c.textContent; }).join("\u0003");
      if (!d || d.dataset.struktur !== struktur) {
        if (d) d.remove();
        d = el("details", "wb-filter-select");
        d.dataset.struktur = struktur;
        d.dataset.name = name;
        if (offen[name]) d.open = true;
        d.addEventListener("toggle", function () { offen[name] = d.open; });
        var kopf = el("summary");
        var symbol = g.firstElementChild && g.firstElementChild.querySelector("svg");
        if (symbol) kopf.appendChild(symbol.cloneNode(true));
        kopf.appendChild(el("span", "", name));
        // × setzt die Auswahl der Gruppe zurück (ohne die Liste zu öffnen); nur sichtbar, solange Einträge gewählt sind (CSS: .active)
        var loesche = el("button", "wb-filter-clear");
        loesche.type = "button";
        loesche.title = "Auswahl zurücksetzen";
        loesche.setAttribute("aria-label", name + ": Auswahl zurücksetzen");
        loesche.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        loesche.addEventListener("click", function (e) {
          e.preventDefault(); e.stopPropagation();   // sonst klappt das <summary> die Liste auf
          // Die App zeichnet die Filterzeile nach jedem Klick neu: Gruppe und Schaltfläche jedes Mal neu suchen
          for (var n = 0; n < 50; n++) {
            var gr = filter.querySelectorAll(".wb-filter-group, .wb-filter-gruppe")[gi];
            var an = gr && chips(gr).filter(function (q) { return q.classList.contains("active") || q.classList.contains("aktiv") || q.getAttribute("aria-pressed") === "true"; })[0];
            if (!an) break;
            an.click();
          }
        });
        kopf.appendChild(loesche);
        d.appendChild(kopf);
        var liste = el("div", "wb-filter-list");
        k.forEach(function (c, ci) {
          var l = el("label", "wb-option");
          var cb = el("input");
          cb.type = "checkbox";
          cb.addEventListener("change", function () {
            var gr = filter.querySelectorAll(".wb-filter-group, .wb-filter-gruppe")[gi];
            var q = gr && chips(gr)[ci];
            if (q) q.click();
          });
          l.appendChild(cb);
          l.title = c.textContent;
          l.appendChild(el("span", "", c.textContent));
          liste.appendChild(l);
        });
        d.appendChild(liste);
        g.parentNode.insertBefore(d, g.nextSibling);
      }
      if (!g.hasAttribute("data-as-list")) g.setAttribute("data-as-list", "");
      var an = k.map(function (c) { return c.classList.contains("active") || c.classList.contains("aktiv") || c.getAttribute("aria-pressed") === "true"; });
      var n = an.filter(Boolean).length;
      var titel = name + (n ? " (" + n + ")" : "");
      var txt = d.firstChild.querySelector("span");
      if (txt.textContent !== titel) txt.textContent = titel;
      d.classList.toggle("active", n > 0);
      Array.prototype.forEach.call(d.querySelectorAll("input"), function (cb, i) { if (cb.checked !== an[i]) cb.checked = an[i]; });
    });
  }

  // Eigene Zeile (.full-row) fluchtet mit der ersten Pillengruppe (seit 1.124.0): Steht vor den Pillen eine Auswahlliste, wird der linke Rand der ersten Pillengruppe gemessen und als --row-indent
  // (Einzug in px) an der Filterzeile gesetzt; ohne Auswahlliste davor bleibt der Einzug 0. style löst den MutationObserver nicht aus.
  function zeilenEinzug(filter) {
    var einzug = 0;
    if (!filter.hidden && filter.offsetParent && filter.querySelector(".wb-filter-group.full-row, .wb-filter-gruppe.full-row")) {
      var sichtbar = Array.prototype.filter.call(filter.children, function (c) { return !c.hasAttribute("data-as-list") && !c.classList.contains("full-row") && c.offsetParent; });
      var erste = sichtbar[0];
      if (erste && erste.classList.contains("wb-filter-select")) {
        var pillen = sichtbar.filter(function (c) { return c.classList.contains("wb-filter-group") || c.classList.contains("wb-filter-gruppe"); })[0];
        if (pillen && Math.abs(pillen.getBoundingClientRect().top - erste.getBoundingClientRect().top) < 8) {
          einzug = Math.max(0, Math.round(pillen.getBoundingClientRect().left - filter.getBoundingClientRect().left));
        }
      }
    }
    var wert = einzug + "px";
    if (filter.style.getPropertyValue("--row-indent") !== wert) filter.style.setProperty("--row-indent", wert);
  }

  // Breite Darstellung (ab 1000 px, Filterzeile sichtbar): Jede Gruppe soll in eine Zeile passen. Passt sie nicht, werden nur ihre längsten Einträge mit „…“ gekürzt
  // (größte gemeinsame Höchstbreite, die alle Einträge samt Beschriftung in die Zeile bringt); kurze Einträge bleiben unverändert. data-einzeilig und style.maxWidth
  // lösen den MutationObserver nicht aus.
  var MIN_BREITE = 48;   // schmaler wird kein Eintrag gekürzt; reicht es dann nicht, darf die Gruppe wie bisher umbrechen
  function gruppeEinzeilig(filter, g) {
    var k = chips(g);
    g.removeAttribute("data-einzeilig");
    k.forEach(function (c) { c.style.maxWidth = ""; });
    if (!k.length) return;
    var verfuegbar = filter.clientWidth - 2;
    var vorn = g.firstElementChild ? g.firstElementChild.getBoundingClientRect().width + 2 : 0;   // Beschriftung samt Außenabstand
    var fest = vorn + 4 * k.length;                                                                  // Beschriftung und Lücken (gap 4 px)
    var breiten = k.map(function (c) { return c.getBoundingClientRect().width; });
    function summe(w) { return breiten.reduce(function (a, b) { return a + Math.min(b, w); }, fest); }
    var natuerlich = summe(Infinity);
    if (natuerlich <= verfuegbar) return;
    if (summe(MIN_BREITE) > verfuegbar) return;
    var lo = MIN_BREITE, hi = Math.ceil(Math.max.apply(null, breiten));
    while (lo < hi) {   // größtes w mit summe(w) <= verfuegbar
      var mid = Math.ceil((lo + hi) / 2);
      if (summe(mid) <= verfuegbar) lo = mid; else hi = mid - 1;
    }
    g.setAttribute("data-einzeilig", "");
    k.forEach(function (c, i) {
      if (breiten[i] > lo) { c.style.maxWidth = lo + "px"; if (!c.title) c.title = c.textContent.trim(); }
    });
  }
  function filterEinzeilig(filter) {
    if (filter.hidden || !filter.offsetParent || !filter.clientWidth) return;   // bis 1000 px steht die Auswahlliste statt der Gruppen
    Array.prototype.forEach.call(filter.querySelectorAll(".wb-filter-group:not([data-as-list]):not(.always-pills), .wb-filter-gruppe:not([data-as-list]):not(.always-pills)"), function (g) { gruppeEinzeilig(filter, g); });
  }

  // Felder nebeneinander (seit 1.107.0): Bezeichnungen mit verschieden vielen Zeilen bekommen je Rasterzeile dieselbe Mindesthöhe, damit die Eingabefelder der Nachbarn
  // auf gleicher Höhe stehen (ein Hilfetext schiebt nur den Raum darunter). Reine Messung und style.minHeight; löst den MutationObserver nicht aus.
  function felderAusrichten() {
    Array.prototype.forEach.call(document.querySelectorAll(".wb-grid"), function (g) {
      var felder = Array.prototype.filter.call(g.children, function (f) { return f.classList.contains("wb-field") && f.firstElementChild && f.firstElementChild.tagName === "LABEL"; });
      felder.forEach(function (f) { if (f.firstElementChild.style.minHeight) f.firstElementChild.style.minHeight = ""; });
      if (felder.length < 2 || !g.offsetParent) return;   // verborgener Reiter: nichts messbar
      var zeilen = {};
      felder.forEach(function (f) {
        var y = Math.round(f.getBoundingClientRect().top);
        (zeilen[y] = zeilen[y] || []).push(f.firstElementChild);
      });
      Object.keys(zeilen).forEach(function (y) {
        var ls = zeilen[y];
        if (ls.length < 2) return;
        var h = Math.max.apply(null, ls.map(function (l) { return l.getBoundingClientRect().height; }));
        ls.forEach(function (l) { l.style.minHeight = h + "px"; });
      });
    });
  }

  function aktualisiere() {
    felderAusrichten();
    Array.prototype.forEach.call(document.querySelectorAll(".wb-tabs"), reiterSync);
    Array.prototype.forEach.call(document.querySelectorAll(".wb-filter"), langeGruppen);
    Array.prototype.forEach.call(document.querySelectorAll(".wb-filter"), filterSync);
    Array.prototype.forEach.call(document.querySelectorAll(".wb-filter"), filterEinzeilig);
    Array.prototype.forEach.call(document.querySelectorAll(".wb-filter"), zeilenEinzug);
  }

  var geplant = false;
  function plane() {
    if (geplant) return;
    geplant = true;
    window.requestAnimationFrame(function () { geplant = false; aktualisiere(); });
  }


  // Umbruchfeld (.wb-wrap, früher .wb-umbruch, seit 1.76.0): einzeiliges Feld, das auf dem Handy (bis 600 px) umbricht und mit seinem Text (und Platzhalter) wächst.
  // Markup: <textarea class="wb-wrap" rows="1" id="…"></textarea> statt <input type="text">. Ab 600 px bleibt es eine Zeile ohne Umbruch.
  // Die Eingabetaste fügt nie einen Zeilenumbruch ein, eingefügte Zeilenumbrüche werden zu Leerzeichen; der Wert bleibt einzeilig.
  var HANDY = window.matchMedia ? window.matchMedia("(max-width: 600px)") : { matches: false };
  function umbruchAnpassen(t) {
    if (!HANDY.matches) { if (t.style.height) t.style.height = ""; return; }
    var leer = !t.value;
    var marke = t.value + "|" + (t.classList.contains("placeholder-clip") ? "" : t.placeholder) + "|" + t.clientWidth;
    if (t.getAttribute("data-umbruch") === marke) return;
    var klemmen = t.classList.contains("placeholder-clip");   // seit 1.127.0: der Platzhalter vergrößert das Feld nicht (er wird abgeschnitten)
    if (leer && t.placeholder && !klemmen) t.value = t.placeholder;   // Platzhalter mitmessen, damit er vollständig lesbar ist
    t.style.height = "auto";
    t.style.height = (t.scrollHeight + (t.offsetHeight - t.clientHeight)) + "px";
    if (leer && !klemmen) t.value = "";
    t.setAttribute("data-umbruch", marke);
  }
  function umbruchAlle() { Array.prototype.forEach.call(document.querySelectorAll("textarea.wb-wrap, textarea.wb-umbruch"), umbruchAnpassen); }
  // Höhe der festen Reiterleiste bzw. des Reitermenüs als --sticky-oben (seit 1.126.0): Zweite feste Leisten (.wb-sticky-bar) und die feststehende Liste (.wb-split.sticky-list) stehen darunter
  function stickyOben() {
    var hoehe = 0, kandidaten = document.querySelectorAll(".wb-tabs-select, .wb-tabs");
    for (var i = 0; i < kandidaten.length; i++) {
      var r = kandidaten[i].getBoundingClientRect();
      if (r.height > 0 && window.getComputedStyle(kandidaten[i]).position === "sticky") { hoehe = Math.ceil(r.height); break; }
    }
    if (document.documentElement.getAttribute("data-sticky-oben") !== String(hoehe)) { document.documentElement.setAttribute("data-sticky-oben", String(hoehe)); document.documentElement.style.setProperty("--sticky-oben", hoehe + "px"); }
  }
  function stickyStart() {
    window.addEventListener("resize", stickyOben);
    window.setInterval(stickyOben, 500);
    stickyOben();
  }

  // Mehrzeilige Felder wachsen mit (seit 1.118.0): jedes <textarea> in .wb-field (außer dem Umbruchfeld) wird beim Tippen so hoch wie sein Text, mindestens so hoch wie seine rows.
  // Ausgeblendete Felder (Reiter nicht aktiv) werden gemessen, sobald sie sichtbar sind; die Marke verhindert unnötige Messungen.
  function wachsAnpassen(t) {
    if (!t.clientWidth) return;
    var marke = t.value + "|" + t.clientWidth;
    if (t.getAttribute("data-wachs") === marke) return;
    t.style.height = "auto";
    t.style.height = (t.scrollHeight + (t.offsetHeight - t.clientHeight)) + "px";
    t.setAttribute("data-wachs", marke);
  }
  function wachsAlle() { Array.prototype.forEach.call(document.querySelectorAll(".wb-field textarea:not(.wb-wrap):not(.wb-umbruch)"), wachsAnpassen); }
  function wachsStart() {
    document.addEventListener("input", function (e) {
      var t = e.target;
      if (t.tagName === "TEXTAREA" && t.closest && t.closest(".wb-field") && !t.classList.contains("wb-wrap") && !t.classList.contains("wb-umbruch")) { t.removeAttribute("data-wachs"); wachsAnpassen(t); }
    });
    window.addEventListener("resize", wachsAlle);
    window.setInterval(wachsAlle, 400);
    wachsAlle();
  }
  function umbruchStart() {
    document.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.target.classList && (e.target.classList.contains("wb-wrap") || e.target.classList.contains("wb-umbruch"))) e.preventDefault();
    });
    document.addEventListener("input", function (e) {
      var t = e.target;
      if (!t.classList || !(t.classList.contains("wb-wrap") || t.classList.contains("wb-umbruch"))) return;
      if (/[\r\n]/.test(t.value)) { var p = t.selectionStart; t.value = t.value.replace(/\s*[\r\n]+\s*/g, " "); try { t.setSelectionRange(p, p); } catch (x) {} }
      t.removeAttribute("data-umbruch"); umbruchAnpassen(t);
    });
    // Werte, die die App per Skript setzt (ohne Ereignis), und Breitenänderungen (Drehen, Fenstergröße) nachziehen
    window.addEventListener("resize", umbruchAlle);
    if (HANDY.addEventListener) HANDY.addEventListener("change", umbruchAlle);
    window.setInterval(umbruchAlle, 400);
    umbruchAlle();
  }

  // Zuklappbare Abschnitte (seit 1.149.0): .wb-form-section.collapsible mit Knopf .wb-section-toggle in der Überschrift.
  // Der Zustand gilt je Gerät (localStorage, nur Komfort); ohne Speicher (privates Fenster) startet jeder Abschnitt aufgeklappt.
  function abschnittSchluessel(sec) { return sec.id ? "wbCollapsed:" + location.pathname + "#" + sec.id : null; }
  function abschnittSetzen(sec, zu) {
    sec.classList.toggle("collapsed", zu);
    var knopf = sec.querySelector(".wb-section-toggle");
    if (knopf) knopf.setAttribute("aria-expanded", String(!zu));
  }
  function abschnitteStart() {
    Array.prototype.forEach.call(document.querySelectorAll(".wb-form-section.collapsible"), function (sec) {
      var k = abschnittSchluessel(sec), wert = null;
      try { wert = k ? localStorage.getItem(k) : null; } catch (e) { /* kein Speicher */ }
      if (wert === "1" || wert === "0") abschnittSetzen(sec, wert === "1");
    });
    document.addEventListener("click", function (e) {
      var knopf = e.target && e.target.closest ? e.target.closest(".wb-section-toggle") : null;
      var sec = knopf && knopf.closest(".wb-form-section.collapsible");
      if (!sec) return;
      var zu = !sec.classList.contains("collapsed");
      abschnittSetzen(sec, zu);
      var k = abschnittSchluessel(sec);
      try { if (k) localStorage.setItem(k, zu ? "1" : "0"); } catch (err) { /* kein Speicher */ }
    });
  }

  function start() {
    aktualisiere();
    abschnitteStart();
    umbruchStart();
    wachsStart();
    stickyStart();
    window.addEventListener("resize", plane);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(plane);
    new MutationObserver(plane).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["aria-selected", "aria-pressed", "class", "hidden"] });
    // Reiter mit Linie (.line-tabs): Sobald die Seite gescrollt ist, bekommt die feste Leiste eine dünne Kante (Klasse page-scrolled auf <html>)
    function kante() { document.documentElement.classList.toggle("page-scrolled", (window.pageYOffset || document.documentElement.scrollTop || 0) > 0); }
    window.addEventListener("scroll", kante, { passive: true });
    kante();
    // Seite scrollt wirklich (Inhalt höher als das Fenster): Klasse page-scrolls auf <html>, damit sie am Rand ausläuft/federt (design.css, seit 1.116.0)
    function scrollt() { var d = document.documentElement; d.classList.toggle("page-scrolls", d.scrollHeight > (window.innerHeight || d.clientHeight) + 1); }
    window.addEventListener("resize", scrollt);
    new MutationObserver(scrollt).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "hidden"] });
    window.addEventListener("load", scrollt);
    scrollt();
    // Tippen außerhalb schließt eine offene Filterliste
    document.addEventListener("click", function (e) {
      if (!e.isTrusted) return;   // die Klicks auf die Originalschaltflächen (k.click()) sind kein Tippen außerhalb
      Array.prototype.forEach.call(document.querySelectorAll(".wb-tabs-select.open"), function (box) { if (!box.contains(e.target)) schliesseReiterMenue(box); });
      Array.prototype.forEach.call(document.querySelectorAll(".wb-filter-select[open]"), function (d) { if (!d.contains(e.target)) d.open = false; });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
